import { BrowserClient, Scope, defaultStackParser, makeFetchTransport } from '@sentry/browser'

const DSN = 'https://4e91e560594b9eb433c8961c15019a30@o77140.ingest.us.sentry.io/4509114188627968'

// Cliente aislado y sin integraciones: el widget corre dentro del sitio del hotel, un Sentry.init
// capturaría los errores del sitio y chocaría con el Sentry que el propio sitio pueda tener
let scope: Scope | null = null

function getScope(): Scope {
   if (!scope) {
      const client = new BrowserClient({
         dsn: DSN,
         enabled: process.env.NODE_ENV === 'production',
         transport: makeFetchTransport,
         stackParser: defaultStackParser,
         integrations: [],
      })
      scope = new Scope()
      scope.setClient(client)
      scope.setTag('app', 'widget-booker')
      client.init()
   }
   return scope
}

const reportedGaCookies = new Set<string>()

export function reportUnknownGaCookieFormat(cookieName: string, cookieValue: string) {
   if (reportedGaCookies.has(cookieName)) {
      return
   }
   reportedGaCookies.add(cookieName)
   getScope().captureMessage('widget-booker: cookie de GA con formato desconocido, se omitió del _gl', 'warning', {
      captureContext: {
         tags: { host: window.location.hostname, cookie: cookieName.startsWith('_ga_') ? '_ga_<stream>' : cookieName },
         // solo el prefijo de formato, el resto es el client/session id del usuario
         extra: { cookieName, formatPrefix: cookieValue.slice(0, 6) },
      },
   })
}
